module.exports = __webpack_public_path__ + "img/realme-Website-Logo-1-768x682.cecc9776.png";